import React, { useMemo } from 'react';
import { Chip } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import moment from 'moment';
import {
  LocalizedQuiz,
  QuizDisplayStatus,
  QuizStatus,
  QuizType,
} from './types';

type Props = {
  quiz: LocalizedQuiz;
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 4,
    color: 'rgba(0,0,0,.6)',
    fontWeight: 600,
    textTransform: 'capitalize',
  },
  gray: {
    border: '1px solid #DADADA',
    backgroundColor: 'transparent',
    color: '#6B6B6B',
  },
  blue: {
    backgroundColor: theme.palette.primary.light,
    color: '#3E7DA2',
  },
  green: {
    backgroundColor: '#E7F1EA',
    color: '#398360',
  },
  red: {
    backgroundColor: '#FCECEC',
    color: '#D04444',
  },
}));

const resolveDisplayStatus = (quiz: LocalizedQuiz) => {
  // Statuses for quizType of `QUIZ` directly flow, as does `DRAFT` for all types.
  if (quiz.quizType === QuizType.POLL && quiz.status === QuizStatus.PUBLISHED) {
    const now = moment();
    const isActive = now.isSameOrAfter(moment(quiz.publishDate));
    const isExpired = now.isSameOrAfter(moment(quiz.expireDate));

    if (isExpired) {
      return QuizDisplayStatus.COMPLETED;
    }
    if (isActive) {
      return QuizDisplayStatus.ACTIVE;
    }
  }

  return quiz.status;
};

const QuizStatusChip = (props: Props) => {
  const { quiz } = props;

  const classes = useStyles();

  const statusToClass = {
    DRAFT: classes.gray,
    ACTIVE: classes.blue,
    PUBLISHED: classes.blue,
    COMPLETED: classes.green,
    UNPUBLISHED: classes.red,
  };

  const resolvedStatus = useMemo(() => resolveDisplayStatus(quiz), [quiz]);

  return (
    <Chip
      className={`${classes.root} ${statusToClass[resolvedStatus]}`}
      label={resolvedStatus?.toLowerCase()}
    />
  );
};

export default QuizStatusChip;
